import moment from 'moment';
import { useTranslation } from 'react-i18next';

import JourneyListMonth, {
	createdTimestampFromJourneyItem,
} from 'packages/kakapo-ui-kit/components/journey/JourneyListMonth';
import { JourneyItem } from 'packages/kakapo-ui-kit/components/journey/JourneyListItem';
import JourneyListEmptyState from 'packages/kakapo-ui-kit/components/journey/JourneyListEmptyState';

import ListService, {
	ListServiceDateFormat,
} from '../../../kakapo-ui-services/services/common/ListService';
import Nullable from '../../../kakapo-ui-services/types/Nullable';
import { VerticalAlignment } from '../../types/Layout';
import ErrorStateCard from '../cards/ErrorStateCard';
import Spinner from '../common/Spinner';

interface IProps {
	isViewer: boolean;
	items: Array<JourneyItem>;
	error: Nullable<Error>;
	isLoading: boolean;
}

export default function JourneyList({ isViewer, items, error, isLoading }: IProps) {
	const { t } = useTranslation();

	const sorted = ListService.reduceListToDateFormat(
		items
			// Sort on createdAt descending
			.sort((a, b) => {
				return (
					new Date(createdTimestampFromJourneyItem(b)).getTime() -
					new Date(createdTimestampFromJourneyItem(a)).getTime()
				);
			})
			.map((item) => ({
				...item,
				timestamp: moment(createdTimestampFromJourneyItem(item)).toDate(),
			})),
		ListServiceDateFormat.Month,
	);
	const sortedMonths = Object.keys(sorted).sort((a, b) => (a > b ? -1 : 1));

	return (
		<Spinner isLoading={isLoading} verticalAlignment={VerticalAlignment.Middle}>
			{error ? (
				<ErrorStateCard error={new Error(t('errors.somethingWentWrong'))} />
			) : (
				<>
					{sortedMonths.length === 0 ? (
						<JourneyListEmptyState isViewer={isViewer} />
					) : (
						sortedMonths.map((month, index) => (
							<JourneyListMonth
								key={moment(month, 'YYYY-MM').format('MMMM YYYY')}
								month={month}
								items={sorted[month]}
								nextMonthItemCount={
									sortedMonths[index + 1] ? sorted[sortedMonths[index + 1]].length : 0
								}
							/>
						))
					)}
				</>
			)}
		</Spinner>
	);
}
